import {Component, OnInit, ViewChild} from '@angular/core';
import {NgxModalDraggableDirective} from '../../../../../directives/draggable.directive';
import {SenderService} from '../../../../../services/sender.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {InterfaceService} from '../../../../../services/interface.service';
import {TelegramService} from '../../../../../pages/page-telegram/telegram.service';
import {map} from 'rxjs/operators';
import {AppService} from '../../../../../services/app.service';

@Component({
  selector: 'app-send-limit',
  templateUrl: './send-limit.component.html',
  styleUrls: ['./send-limit.component.scss']
})
export class SendLimitComponent implements OnInit {
  public modalDirective: NgxModalDraggableDirective;
  public formattedAccount$ = this.senderService.account$.pipe(
    map((account) =>  this.formatAccountValue(account.accounts?.length))
  );
  public accountsCount$ = this.senderService.account$.pipe(
    map((account) =>  account.accounts.filter((v) => v.authorized)?.length)
  );
  format = (percent: number): string => `${this.formatAccountValue(percent)} до ${percent * 10} сообщений/сутки в лс.`;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(
    public appService: AppService,
    public telegramService: TelegramService,
    public interfaceService: InterfaceService,
    public senderService: SenderService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {

  }
  formatAccountValue(count: number): string {
    return this.appService.declOfNum(count, ['# аккаунт', '# аккаунта', '# аккаунтов']);
  }
  addAccount() {
    this.interfaceService.addAccount(this.telegramService);
  }
}
